import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'truncateHtml'
})
export class TruncateHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, limit: number = 200): SafeHtml {
    if (!value) return '';

    // Strip HTML tags to get plain text
    const plainText = value.replace(/<[^>]*>/g, '');

    // Truncate to desired limit
    const truncated = plainText.length > limit
      ? plainText.substring(0, limit) + '...'
      : plainText;

    // Return as SafeHtml so Angular can bind it with [innerHTML]
    return this.sanitizer.bypassSecurityTrustHtml(truncated);
  }
}
